import * as yup from 'yup'

export class CompanyBuyerCompanyDto {
  buyerCode?: string = undefined
  // dealerNumber?: string = undefined
  // irsNumber?: string = undefined
}

export const companyBuyerCompanyValidationSchema = yup.object<CompanyBuyerCompanyDto>({
  buyerCode: yup
    .string()
    .min(3, 'Buyer Code must be 3 characters.')
    .max(3, 'Buyer Code must be 3 characters.')
    .required('Buyer Code is required.')
  // dealerNumber: yup.string().required('Dealer # is required.'),
  // irsNumber: yup.string().required('IRS # is required.')
})
